<div
  class="card card-inactive border-3"
  [class.border-primary]="hover"
  (dragover)="hover = true"
  (dragleave)="hover = false"
>
  <div class="card-body py-5 mt-5 mb-3">
    <input hidden type="file" #fileInput />

    <p class="h2">
      {{ 'Drag and Drop %type%' | translate: { type: name } }}
    </p>
    <p class="text-muted">
      {{ 'or' | translate }}
    </p>
    <p>
      <a href (click)="fileInput.click(); (false)">{{
        'Click here to select file to upload' | translate
      }}</a>
    </p>
    <p class="text-muted">
      {{ 'Supported file types' | translate }}: xml, pdf, jpg, jpeg, png
    </p>
  </div>
</div>
